// extracted by mini-css-extract-plugin
module.exports = {"image":"Image-module--image--2t_8E"};